module.exports = __webpack_public_path__ + "Roboto-Light.37fbbbad5577a95bdf05.woff";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-Light.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Light.woff
// module chunks = styles